import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { ChatRecordsOnRequestModel } from '../views/models/chat-records-on-request.model';
import { ProfileModel } from '../views/models/profile.model';
import { AppHotelService } from './app-hotel.service';

@Injectable({
  providedIn: 'root'
})
export class LiveSupportService {

  profiles: ProfileModel[] = [];

  constructor(
    private http: HttpClient,
    private hotelServ: AppHotelService,
    private router: Router,
    private translateService: TranslateService
  ) { }

  getChats(): Promise<ProfileModel[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/profiles?chat_badge_a_list=1').subscribe((res: ProfileModel[]) => {
        res = res.filter(x => x.first_name);
        res = res.sort((a, b) => b.badge_a - a.badge_a);
        this.profiles = res;
        console.log(this.profiles);
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }

  getChatHistory(profileId: number): Promise<ChatRecordsOnRequestModel[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/profiles/' + profileId + '/chat_log').subscribe((res: ChatRecordsOnRequestModel[]) => {
        resolve(res);
      }, (err) => {
        reject(err);
      });
    });
  }

  postLiveSupportMessage(profileId: number, data: ChatRecordsOnRequestModel) {
    return new Promise((resolve, reject) => {
      data.record_type = 'HotSupport';
      this.http.post(environment.apiURL + '/profiles/' + profileId + '/chat_log', data).subscribe(
        {
          next: (resp) => {
            resolve(resp);
          },
          error: err => {
            reject(err);
          }
        });
    });
  }

  connectLiveSupportWs(profileId: number): WebSocketSubject<ChatRecordsOnRequestModel> {
    const URL = `${environment.baseURL.replace('https', 'wss')}/hot_support/${profileId}/ws`;

    const WS = webSocket(URL) as WebSocketSubject<ChatRecordsOnRequestModel>;

    return WS;
  }

  getTranslate(key: string): Promise<string> {
    return new Promise((resolve) => {
      this.translateService.get(key).subscribe(
        (value: string) => {
          resolve(value);
        });
    });
  }

  async newMessagesSocket(): Promise<void> {
    const HOTEL = await this.hotelServ.getHotelInfoPromise(+JSON.parse(localStorage.getItem('token_form')).app_hotel_id);

    const URL = `${environment.baseURL.replace('https', 'wss')}/hot_support4Hotel/${(HOTEL.group_hotels.split(',').join('-') ? HOTEL.group_hotels.split(',').join('-') : HOTEL.id.toString())}/ws`;

    const WS = webSocket(URL) as WebSocketSubject<ChatRecordsOnRequestModel>;
    console.log(WS);
    WS.subscribe({
      next: async (chat) => {
        this.getChats();

        if (this.router.url !== '/home/live-support') {
          let mTitle = await this.getTranslate('New Message');
          Swal.fire({
            icon: 'info',
            title: `${mTitle} ${chat.user_name}`,
            text: chat.message,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'View'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/home/live-support']);
            }
          });
        }

        try {
          const AUD = new Audio('assets/audio/notification.mp3');
          AUD.play();
        } catch { }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

}
